import type { PowerAllocation, SystemId } from "./types";

export const RELEASE_VERSION = "0.3.0-rc.1";
export const FIXED_STEP = 1 / 60;
export const RUN_DURATION = 180;
export const ARENA_RADIUS = 30;

export const SYSTEMS: SystemId[] = [
  "propulsion",
  "sonar",
  "shield",
  "repair",
  "weapons",
];

export const INITIAL_POWER: PowerAllocation = {
  propulsion: 2,
  sonar: 1,
  shield: 2,
  repair: 2,
  weapons: 3,
};

export const TOTAL_POWER = Object.values(INITIAL_POWER).reduce(
  (total, value) => total + value,
  0,
);

export const WAVE_BOUNDARIES = [0, 45, 95, 135] as const;

export function waveForTime(time: number): number {
  if (time >= WAVE_BOUNDARIES[3]) return 4;
  if (time >= WAVE_BOUNDARIES[2]) return 3;
  if (time >= WAVE_BOUNDARIES[1]) return 2;
  return 1;
}
